import { Component, Input, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-crossreference',
  templateUrl: './help-crossreference.component.html',
})
export class HelpCrossreferenceComponent implements OnInit {

  constructor(public commonDataService: CommonDataService, 
    private graphQlService: GraphqlService, private sanitizer: DomSanitizer, private router: Router) {
    
  }
  cr_header;
  cr_desc;
  cr_para1heading;
  cr_para1body;
  cr_para2header;
  cr_para2body;
  // IsRightPanel:boolean;
  @Input() IsRightPanel:boolean=false;
  ngOnInit(): void {
    // this.IsRightPanel=this.commonDataService.showRightPanel.getValue();
  
    this.commonDataService.showLoader.next(true);
    window.scrollTo(0, 0);
    this.gethelpcrosreferencelabels();
  }

  gethelpcrosreferencelabels() {
    this.graphQlService.gethelpcrossreferenceLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.cr_header = labels.filter(x => x.key == "cr_header").map(y => y.value);
        this.cr_desc = labels.filter(x => x.key == "cr_desc").map(y => y.value);
        this.cr_para1heading = labels.filter(x => x.key == "cr_para1heading").map(y => y.value);
        this.cr_para1body = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "cr_para1body").map(y => y.value));       
        this.cr_para2header = labels.filter(x => x.key == "cr_para2header").map(y => y.value);
        this.cr_para2body = labels.filter(x => x.key == "cr_para2body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }
  openlink(event) {
    let id = event.target.id;
    if (id != "") {
      if (this.router.url == '/Login') {
        this.commonDataService.NavigatingFromComponent.next("helpcrossreference");
        this.commonDataService.childComponent.next(true);
        this.commonDataService.rightPanelWidth.next("rightOverlay_large");
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.rightOverlayOption.next(event.target.name);
      } else {
        this.router.navigate([event.target.id]);
      }
    }

  }
}
